import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["municipioWrapper"]

  toggleMunicipio(event) {
    const checked = event.target.checked

    if (checked) {
      this.municipioWrapperTarget.style.display = 'none'
    } else {
      this.municipioWrapperTarget.style.display = ''
    }
  }
}
